import React, { useEffect, useState, forwardRef } from "react";

import { useTranslation } from "next-i18next";
import SafeArea from "@/components/safe-area";
import PopupView from "@/components/popup-v2";

import { SearchInput, SelectHolder, SelectView, SelectedItem } from "@/components/search-area";
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle, DrawerTrigger } from "../ui/drawer";

interface Props<T> {
	options: T[];
	onChange: (val: string) => void; // Controller filed.onChange方法
	value: string;
	defaultValue?: string;
	placeholder?: string;
	labelLeft?: React.ReactNode | string;
	name?: string; // react-hook-form必须传
	placeholderTextClassName?: string;
	disabled?: boolean;
	renderOption?: (option: T) => React.ReactNode;
}

const SelectArea = forwardRef<HTMLSelectElement, Props<SelectedItem>>((props, ref) => {
	const [selectItem, setSelectItem] = useState<SelectedItem>();
	const [searchText, setSearchText] = useState("");
	const [visible, setVisible] = useState(false);
	const { t } = useTranslation("common");
	useEffect(() => {
		const defaultSelectItem = props.options.find(
			(item) => item.value === props.defaultValue || item.value === props.value,
		);
		if (defaultSelectItem) setSelectItem(defaultSelectItem);
	}, [props.defaultValue, props.options, props.value]);

	const filterOptions = (filterText: string, defaultOptions: SelectedItem[]) => {
		if (!filterText) return defaultOptions;
		return defaultOptions.filter((item) => {
			return (
				item.label.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()) ||
				item.value.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())
			);
		});
	};

	return (
		<>
			<SelectHolder
				text={selectItem?.label}
				placeholder={props.placeholder}
				onClick={() => {
					if (props.disabled) return;
					setVisible(true);
				}}
				labelLeft={props.labelLeft}
				disabled={props.disabled}
			/>
			<Drawer open={visible} onClose={() => setVisible(false)}>
				<DrawerContent>
					<DrawerHeader className="py-2">
						<DrawerTitle></DrawerTitle>
						<DrawerDescription></DrawerDescription>
					</DrawerHeader>
					<div className="mx-auto w-full">
						<SearchInput
							placeholder={t("search")}
							value={searchText}
							onClear={() => setSearchText("")}
							onChange={(val) => setSearchText(val)}
						/>

						<SelectView
							list={filterOptions(searchText, props.options)}
							onSelected={(e) => {
								setSelectItem(e);
								// 其实就是最外层 field.onChange 方法
								props.onChange(e.value);
								setVisible(false);
							}}
							renderOption={props.renderOption}
						/>
						<SafeArea position="bottom" />
					</div>
				</DrawerContent>
			</Drawer>
		</>
	);
});

SelectArea.displayName = "SelectArea";
export default SelectArea;
